import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_help_topics_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/topics?${params}`
	);
	return response.data;
};

export const add_help_topic_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/topics`,
		body
	);
	return response.data;
};

export const update_help_topic_api = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/topics`,
		body
	);
	return response.data;
};

export const delete_help_topic_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/topics?id=${id}`
	);
	return response.data;
};

export const get_help_queries_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/queries?${params}`
	);
	return response.data;
};

export const submit_help_query_api = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/queries`,
		body
	);
	return response.data;
};

export const update_help_query_api = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/queries`,
		body
	);
	return response.data;
};

export const delete_help_query_api = async (id) => {
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/help/queries?id=${id}`
	);
	return response.data;
};
